import { toastr } from 'react-redux-toastr';
import {
  CLEAR_BAGGAGE_DISCOUNT_CODES,
  CLEAR_SPECIAL_BAGGAGE_DISCOUNT_CODES,
  FLAG_GETTING_BAGGAGE_DISCOUNT_CODES,
  FLAG_GETTING_SPECIAL_BAGGAGE_DISCOUNT_CODES,
  GET_BAGGAGE_DISCOUNT_CODES,
  GET_SPECIAL_BAGGAGE_DISCOUNT_CODES,
} from '../types';
import { DEFAULT_GET_CONFIG } from '../../config/rest';
import { DISCOUNT_CODE_ENDPOINT } from '../../config/endpoints';
import { isErrorResponse } from '../../utils/error-handlers';

const flagGettingBaggageDiscountCodes =
  (flag, isSpecial = false) =>
  (dispatch) => {
    const type = isSpecial
      ? FLAG_GETTING_SPECIAL_BAGGAGE_DISCOUNT_CODES
      : FLAG_GETTING_BAGGAGE_DISCOUNT_CODES;
    dispatch({ type, payload: flag });
  };

const getBaggageDiscountCodes =
  (isSpecial = false) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingBaggageDiscountCodes(true, isSpecial));
      const url = `${DISCOUNT_CODE_ENDPOINT}/${
        isSpecial ? 'cargo' : 'baggage'
      }`;
      const response = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(response, null, dispatch);
      const discountCodes = await response.json();
      const type = isSpecial
        ? GET_SPECIAL_BAGGAGE_DISCOUNT_CODES
        : GET_BAGGAGE_DISCOUNT_CODES;
      dispatch({ type, payload: discountCodes });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingBaggageDiscountCodes(false, isSpecial));
    }
  };

const clearBaggageDiscountCodes =
  (isSpecial = false) =>
  (dispatch) => {
    const type = isSpecial
      ? CLEAR_SPECIAL_BAGGAGE_DISCOUNT_CODES
      : CLEAR_BAGGAGE_DISCOUNT_CODES;
    dispatch({ type });
  };

export { getBaggageDiscountCodes, clearBaggageDiscountCodes };
